const removeLeadingSlash = (filePath) => filePath.replace(/^\/+/, '');

module.exports.removeLeadingSlash = removeLeadingSlash;
